import { TRootState } from '../@types/redux'

export const selectModalClinicalCase = (state: TRootState) => state.clinicalCases.clinicalCaseModalIsOpen

export const selectIsUpdateClinicalCase = (state: TRootState) => state.clinicalCases.isUpdateClinicalCase

export const selectClinicalCaseForUpdate = (state: TRootState) => state.clinicalCases.clinicalCaseForUpdate

export const selectClinicalCaseRefreshTable = (state: TRootState) => state.clinicalCases.refreshTableClinicalCases